export default "__VITE_ASSET__58fd00d1__"